export default __webpack_public_path__ + "static/media/empty-icon.957d40cf.svg";